import { useState } from 'react';

import {
  Container,
  FieldSection,
  SectionTitle,
  Button,
  Description
} from '../configuration-sections.styles';

import Client from '../../../../tools/client';
const client = new Client();

const DataConfigurationDisplay = () => {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState('');

  const handleDownloadMedia = async () => {
    setDownloading(true);
    setError('');
    try {
      await client.downloadMedia();
    } catch (err) {
      setError('Failed to download media. Please try again.');
    }
    setDownloading(false);
  };

  return (
    <Container>
      <FieldSection>
        <SectionTitle>Download All Media</SectionTitle>
        <Description>
          Downloads all uploaded images, audio, and video files as a compressed .tar.gz archive.
        </Description>
        <Button primary onClick={handleDownloadMedia} disabled={downloading}>
          {downloading ? 'Downloading...' : 'Download All Media'}
        </Button>
        {error && <p style={{ color: 'red', marginTop: '0.5rem' }}>{error}</p>}
      </FieldSection>
    </Container>
  );
};

export default DataConfigurationDisplay;
